import React from "react";
import { BRAND, WHATSAPP_LINK } from "@/lib/constants";
import { Phone, MessageCircle, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-brand-green-deep text-white relative overflow-hidden" data-testid="site-footer">
      <div className="grain-overlay opacity-50" />
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl py-14 relative">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-brand-gold to-brand-gold-light flex items-center justify-center">
                <span className="text-brand-green font-heading font-black text-xl">M</span>
              </div>
              <div>
                <div className="font-heading font-extrabold text-lg text-white">{BRAND.name}</div>
                <div className="text-xs text-brand-gold font-semibold">{BRAND.tagline}</div>
              </div>
            </div>
            <p className="text-white/70 text-sm leading-relaxed max-w-md">
              نوفر لك سيولة مالية فورية من 1,000 إلى 25,000 ريال بطريقة شرعية وسريعة
              عبر منصات تابي وتمارا، مع ضمان السرية والأمان التام.
            </p>
          </div>

          <div>
            <div className="font-heading font-extrabold text-brand-gold mb-4">روابط سريعة</div>
            <ul className="space-y-2.5 text-sm">
              {[
                { href: "#how", label: "كيف يعمل" },
                { href: "#benefits", label: "المميزات" },
                { href: "#pricing", label: "العروض" },
                { href: "#sharia", label: "الضمان الشرعي" },
                { href: "#contact", label: "تواصل معنا" },
              ].map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-white/75 hover:text-brand-gold transition">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="font-heading font-extrabold text-brand-gold mb-4">تواصل معنا</div>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href={`tel:${BRAND.phone}`}
                  className="flex items-center gap-2 text-white/75 hover:text-brand-gold transition"
                >
                  <Phone className="w-4 h-4" /> <span dir="ltr">{BRAND.phone}</span>
                </a>
              </li>
              <li>
                <a
                  href={WHATSAPP_LINK()}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-white/75 hover:text-brand-gold transition"
                >
                  <MessageCircle className="w-4 h-4" /> واتساب
                </a>
              </li>
              <li className="flex items-center gap-2 text-white/75">
                <MapPin className="w-4 h-4" /> المملكة العربية السعودية
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-brand-gold/15 border border-brand-gold/40 flex items-center justify-center">
              <svg viewBox="0 0 24 24" className="w-5 h-5 text-brand-gold-light" fill="currentColor">
                <path d="M12 2L4 6v6c0 5 3.5 9.5 8 10 4.5-.5 8-5 8-10V6l-8-4zm-1 15l-5-5 1.4-1.4L11 14.2l6.6-6.6L19 9l-8 8z"/>
              </svg>
            </div>
            <div className="text-xs md:text-sm">
              <div className="font-heading font-extrabold text-brand-gold-light leading-tight">موثّق من وزارة التجارة</div>
              <div className="text-white/55 leading-tight">المملكة العربية السعودية</div>
            </div>
          </div>
          <div className="text-xs text-white/55 text-center">
            © {new Date().getFullYear()} {BRAND.name} — {BRAND.nameEn} · جميع الحقوق محفوظة.
          </div>
        </div>
      </div>
    </footer>
  );
}
